<template>
  <div>
    <headTop></headTop>
    <div class="cssOrderList">
      <div class="cssOrderListMapping">
        <span class="cssOrderListTitle">应急保障</span>
        <span class="cssOrderListSubTitle">— 订单列表</span>
        <!-- <div class="cssBack" @click="$router.back(-1)" >返回上一步 ></div> -->
      </div>
      <div class="cssOrderItemBox ">
        <div class="cssItemBlock" v-for="(item,index) in allLists" :key="index">
          <!-- <div>{{value.amount}}</div> -->
          <!-- ===========================线下合同 v-if="item.contract_on_line == 0""=================================== -->
          <div v-if="item.tails.contract_on_line == 0">
            <span class="cssStatuTag" v-if="item.order_state == '失效' || item.order_state == '已取消'">交易关闭</span>
            <span class="cssStatuTag" v-else-if="item.pay_state == '未付款' && item.channel != 'remittance'">待付款</span>
            <span class="cssStatuTag" v-else-if="item.pay_state == '未付款' && item.channel == 'remittance'">汇款审核中</span>
            <span class="cssStatuTag" v-else-if="item.pay_state == '已付款' && item.tails.acceptance_status == 0">待验收</span>
            <span class="cssStatuTag" v-else-if="item.pay_state == '已付款' && item.tails.acceptance_status == 1">交易完成</span>
            <span class="cssStatuTag" v-else>{{item.pay_state}}</span>
            <p class="cssOrderId">订单号：{{item.id}}</p>
            <p class="cssOrderCreateTime">订单时间：{{formatTime(item.create_time)}}</p>
            <div class="cssTimeTip" v-if="item.order_state == '失效'">
              您未于{{item.tails.latestDateToPay.split(' ')[0]}} 23:59前完成支付，请重新下单
            </div>
            <div class="cssTimeTip" v-else-if="item.pay_state == '未付款' && item.order_state != '已取消'">
              请于{{item.tails.latestDateToPay.split(' ')[0]}} 23:59前支付完成，超时交易将关闭
            </div>
            <p class="cssItemSubject" @click="jumpTo(item.id)">{{item.subject}} <span class="cssItemBody">{{item.body}}</span> <span class="cssSubjectAmount">￥{{item.amount}}</span></p>
            <p class="cssItemTotal">总计：￥<span class="cssTotalAmount">{{item.amount}}</span></p>
            <div class="cssButtonBox">
              <div v-if="item.order_state == '失效'||item.order_state == '已取消'">
                <button @click="showDelPop(item.id)" class="cssButtonCommon">删除订单</button>
              </div>
              <div v-else-if="item.pay_state == '未付款' && item.channel != 'remittance'">
                <button class="cssButtonCommon" @click="applyClick(item.id,item.amount)">付款</button>
                <button v-if="item.order_state != '已取消'" class="cssButtonCommon" @click="showCanclPop(item.id)">取消订单</button>
                <button v-else-if="item.order_state == '已取消'" class="cssButtonCommon" @click="showDelPop(item.id)">删除订单</button>
                <button class="cssButtonCommon" @click="download(item.tails.solutionsId)">下载合同</button>
              </div>
              <div v-else-if="item.pay_state == '未付款' && item.channel == 'remittance'">
                <button class="cssButtonCommon" @click="download(item.tails.solutionsId)">下载合同</button>
              </div>
              <div v-else-if="item.pay_state == '已付款' && item.amount != 0 && item.tails.acceptance_status == 0">
                <button class="cssButtonCommon" @click="showAccPop(item.tails.solutionsId)">项目验收</button>
                <button class="cssButtonCommon" v-if="item.tails.contract_img" @click="hetong(item.tails.contract_img)">查看合同</button>
                <button v-if="item.invoice_state == '已申请'" class="cssButtonCommon disable">已申请</button>
                <button v-else-if="item.invoice_state == '已开具'" class="cssButtonCommon disable">已开票</button>
                <button v-else class="cssButtonCommon " @click="goApplicationInvoice">申请开票</button>
              </div>
              <div v-if="item.pay_state == '已付款' && item.amount != 0 && item.tails.acceptance_status != 0">
                <button class="cssButtonCommon" v-if="item.tails.contract_img" @click="hetong(item.tails.contract_img)">查看合同</button>
                <button @click="showDelPop(item.id)" class="cssButtonCommon">删除订单</button>
                <button v-if="item.invoice_state == '已申请'" class="cssButtonCommon disable">已申请</button>
                <button v-else-if="item.invoice_state == '已开具'" class="cssButtonCommon disable">已开票</button>
                <button v-else class="cssButtonCommon " @click="goApplicationInvoice">申请开票</button>
              </div>
            </div>
          </div>

          <!-- ===========================线上合同 v-else-if="item.contract_on_line == 1"=================================== -->
          <div v-else-if="item.tails.contract_on_line == 1">
            <span class="cssStatuTag" v-if="item.order_state == '失效' || item.order_state == '已取消'">交易关闭</span>
            <span class="cssStatuTag" v-else-if="item.tails.contract_online_status == '待实名' && item.pay_state == '未付款'">待实名</span>
            <span class="cssStatuTag" v-else-if="item.tails.contract_online_status == '待认证' && item.pay_state == '未付款'">待认证</span>
            <span class="cssStatuTag" v-else-if="item.tails.contract_online_status == '待授权' && item.pay_state == '未付款'">待授权</span>
            <span class="cssStatuTag" v-else-if="item.tails.contract_online_status == '待签署' && item.pay_state == '未付款'">待签署</span>
            <span class="cssStatuTag" v-else-if="item.tails.contract_online_status == '待签署' && item.tails.contract_status == '已发起' && item.pay_state == '未付款'">等待签署完成</span>
            <span class="cssStatuTag" v-else-if="item.tails.contract_online_status != '待签署'
                                                && item.tails.contract_online_status != '待授权'
                                                && item.tails.contract_online_status != '待认证'
                                                && item.tails.contract_online_status != '待实名'
                                                && item.pay_state == '未付款'
                                                && item.channel != 'remittance'">待付款</span>
            <span class="cssStatuTag" v-else-if="item.pay_state == '未付款' && item.channel == 'remittance'">汇款审核中</span>
            <span class="cssStatuTag" v-else-if="item.pay_state == '已付款' && item.tails.acceptance_status == 0">待验收</span>
            <span class="cssStatuTag" v-else-if="item.pay_state == '已付款' && item.tails.acceptance_status == 1">交易完成</span>
            <p class="cssOrderId">订单号：{{item.id}}</p>
            <p class="cssOrderCreateTime">订单时间：{{formatTime(item.create_time)}}</p>
            <div class="cssTimeTip" v-if="item.order_state == '失效'">
              您未于{{item.tails.latestDateToPay.split(' ')[0]}} 23:59前完成支付，请重新下单
            </div>
            <div class="cssTimeTip" v-else-if="item.pay_state == '未付款' && item.order_state != '已取消'">
              请于{{item.tails.latestDateToPay.split(' ')[0]}} 23:59前支付完成，超时交易将关闭
            </div>
            <!-- <p class="cssItemBody">{{item.body}}</p> -->
            <p @click="jumpTo(item.id)" class="cssItemSubject">{{item.subject}} <span class="cssItemBody">{{item.body}}</span> <span class="cssSubjectAmount">￥{{item.amount}}</span></p>
            <p class="cssItemTotal">总计：￥<span class="cssTotalAmount">{{item.amount}}</span></p>
            <div class="cssButtonBox">
              <div v-if="item.order_state == '失效'|| item.order_state == '已取消'">
                <button @click="showDelPop(item.id)" class="cssButtonCommon">删除订单</button>
              </div>
              <div v-else-if="item.pay_state == '未付款' && item.tails.contract_online_status == '待实名'">
                <button @click="goToContract(item.tails.solutionsId)" class="cssButtonCommon">实名认证</button>
              </div>
              <div v-else-if="item.pay_state == '未付款' && item.tails.contract_online_status == '待认证'">
                <button @click="goToCompContract(item.tails.solutionsId)" class="cssButtonCommon">企业认证</button>
                <!-- <button @click="changeContract(item.id)"
                        class="cssButtonCommon">更换签署</button> -->
              </div>
              <div v-else-if="item.pay_state == '未付款' && item.tails.contract_online_status == '待授权'">
                <button @click="sendContract(item.tails.solutionsId)" class="cssButtonCommon">发送授权</button>
              </div>
              <div v-else-if="item.pay_state == '未付款' && item.tails.contract_online_status == '待签署' && item.tails.legal_status == '已授权'">
                <button @click="contractClick(item.tails.solutionsId)" class="cssButtonCommon">签署合同</button>
                <!--                <a :href="static_url + 'company-auth?planId='+ item.tails.solutionsId" target="_blank"><button class="cssButtonCommon">签署合同</button></a>-->
                <!-- <a :href="static_host + '/company-auth?planId='+ item.tails.solutionsId"><button @click="goSignContract(item.tails.solutionsId)" class="cssButtonCommon">签署合同</button></a> -->
              </div>
              <div v-else-if="item.pay_state == '未付款' &&
                              item.tails.contract_online_status != '待签署' &&
                              item.tails.contract_online_status != '待授权' &&
                              item.tails.contract_online_status != '待认证' &&
                              item.tails.contract_online_status != '待实名'
                              && item.channel != 'remittance'">
                <button class="cssButtonCommon" @click="applyClick(item.id, item.amount)">付款</button>
                <button v-if="item.order_state != '已取消'" class="cssButtonCommon" @click="showCanclPop(item.id)">取消订单</button>
                <button v-else-if="item.order_state == '已取消'" class="cssButtonCommon" @click="showDelPop(item.id)">删除订单</button>
                <button class="cssButtonCommon" @click="hetongOnline(item.tails.solutionsId)">查看合同</button>
                <!-- <button class="cssButtonCommon"
                        @click="hetongOnline(item.tails.solutionsId)">查看合同</button> -->
              </div>
              <div v-else-if="item.pay_state == '未付款' && item.channel == 'remittance'">
                <button class="cssButtonCommon" @click="hetongOnline(item.tails.solutionsId)">查看合同</button>
              </div>
              <div v-else-if="item.pay_state == '已付款' && item.amount != 0 && item.tails.acceptance_status == 0">
                <button class="cssButtonCommon" @click="showAccPop(item.tails.solutionsId)">项目验收</button>
                <button class="cssButtonCommon" @click="hetongOnline(item.tails.solutionsId)">查看合同</button>
                <button v-if="item.invoice_state == '已申请'" class="cssButtonCommon disable">已申请</button>
                <button v-else-if="item.invoice_state == '已开具'" class="cssButtonCommon disable">已开票</button>
                <button v-else class="cssButtonCommon " @click="goApplicationInvoice">申请开票</button>
              </div>
              <div v-if="item.pay_state == '已付款' && item.amount != 0 && item.tails.acceptance_status == 1">
                <button class="cssButtonCommon" @click="hetongOnline(item.tails.solutionsId)">查看合同</button>
                <button @click="showDelPop(item.id)" class="cssButtonCommon">删除订单</button>
                <button v-if="item.invoice_state == '已申请'" class="cssButtonCommon disable">已申请</button>
                <button v-else-if="item.invoice_state == '已开具'" class="cssButtonCommon disable">已开票</button>
                <button v-else class="cssButtonCommon " @click="goApplicationInvoice">申请开票</button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <!--  支付弹窗  -->
    <div v-show="popflag == true || popDelflag == true || popAcceptflag == true || popApplicateflag == true" class="cssMaskerLayer"></div>
    <div v-if="popflag == true" class="cssPopWindow">
      <div class="cssPopTitle">
        <p>提示</p>
      </div>
      <div class="cssPopBody">
        <p class="cssWranningtext"><span class="cssWranning">!</span>此操作将取消该项目，是否继续？</p>
        <div class="cssBottombutton">
          <button @click="hideCanclPop" class="cssButtonCommon white">取消</button>
          <button @click="cancalFun(currentId)" class="cssButtonCommon">确定</button>
        </div>
      </div>
    </div>
    <div v-if="popDelflag==true" class="cssPopDelWindow">
      <div class="cssPopTitle">
        <p>提示</p>
      </div>
      <div class="cssPopBody">
        <p class="cssWranningtext"><span class="cssWranning">!</span>此操作将删除该项目，是否继续？</p>
        <div class="cssBottombutton">
          <button @click="hideDelPop" class="cssButtonCommon white">取消</button>
          <button @click="delFun(currentId)" class="cssButtonCommon">确定</button>
        </div>
      </div>
    </div>
    <div v-if="popAcceptflag==true" class="cssPopAcceptWindow">
      <div class="cssPopTitle">
        <p>提示</p>
      </div>
      <div class="cssPopBody">
        <p class="cssWranningtext"><span class="cssWranning">!</span>此操作将验收该项目，是否继续？</p>
        <div class="cssBottombutton">
          <button @click="hideAccPop" class="cssButtonCommon white">取消</button>
          <button @click="goAcceptance(currentId)" class="cssButtonCommon">确定</button>
        </div>
      </div>
    </div>
    <div v-if="popApplicateflag==true" class="cssPopAcceptWindow">
      <div class="cssPopTitle">
        <p>提示</p>
      </div>
      <div class="cssPopBody">
        <p class="cssWranningtext"><span class="cssWranning">!</span>请前往PC端申请开票</p>
        <div class="cssBottombutton">
          <button @click="hideAppliPop" class="cssButtonCommon">我知道了</button>
        </div>
      </div>
    </div>
    <payView type="5" :money="orderamount" :orderId="orderid" :show="payViewVisible" @payValue="payValue"></payView>
    <!--  支付成功弹窗  -->
    <SuccessView :show="showSuccessView" type="2" @successViewClick="successViewClick"></SuccessView>
  </div>
</template>
<script>
import headTop from './header'
import mainFooter from '../view/footer'
import payView from '../components/pay'
import { Toast } from 'mint-ui'
import SuccessView from '../components/success-view'
export default {
  name: 'orderlist',
  components: {
    headTop,
    payView,
    mainFooter,
    SuccessView
  },
  data () {
    return {
      showSuccessView: false,
      popflag: false,
      popDelflag: false,
      popAcceptflag: false,
      popApplicateflag: false,
      payViewVisible: false,
      status: 4,
      keyword: '',
      currentPage: 1,
      pageSize: 999,
      allLists: [],
      tableTotal: 0,
      currentId: 0,
      orderid: 0,
      orderamount: 0
    }
  },
  methods: {
    contractClick: function (id) {
      if (
        parseInt(localStorage.getItem('isApp')) === 1 &&
        this.utils.isIphone()
      ) {
        // ios app 内嵌网页 签署合同
        window.webkit.messageHandlers.contractSign.postMessage({ planId: id })
      } else {
        // 签署合同 新窗口打开
        let routeData = this.$router.resolve({
          path: 'auth-online',
          query: { planId: id }
        })
        window.open(routeData.href, '_blank')
      }
    },
    formatTime (ndate) {
      if (!ndate) {
        return '-'
      }
      var date = new Date(ndate * 1000)
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      var hour = date.getHours()
      var minute = date.getMinutes()
      var second = date.getSeconds()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (day >= 0 && day <= 9) {
        day = '0' + day
      }
      if (hour >= 0 && hour <= 9) {
        hour = '0' + hour
      }
      if (minute >= 0 && minute <= 9) {
        minute = '0' + minute
      }
      if (second >= 0 && second <= 9) {
        second = '0' + second
      }
      var result =
        year +
        '-' +
        month +
        '-' +
        day +
        ' ' +
        hour +
        ':' +
        minute +
        ':' +
        second
      return result
    },
    // this.utils.GET(this.accountUrl + '/solutionsConsulting/consultingOrderMoneyInfo?id=' + this.planId, function (response) {
    //         if (response.code === 0) {
    //           _this.planInfo = response.data
    //           _this.isSecurity = 0
    //           _this.iscar = 0
    //           if (_this.planInfo.lease_types.indexOf('安保人员') >= 0) {
    //             _this.isSecurity = 1
    //           }
    //           if (_this.planInfo.lease_types.indexOf('消防车租赁') >= 0) {
    //             _this.iscar = 1
    //           }
    //           if (_this.planInfo.security_typ
    applyClick: function (id, amount) {
      this.orderid = id
      this.orderamount = amount
      this.payViewVisible = true
    },
    payValue: function (state) {
      this.payViewVisible = false
      this.showSuccessView = true
      console.log('============支付回调')
    },
    successViewClick: function () {
      this.showSuccessView = false
      this.getOrderData()
    },

    jumpTo (id) {
      this.$router.push({
        path: '/orderdetail',
        query: {
          orderid: id
        }
      })
    },

    // 实名认证
    goToContract (id) {
      this.$router.push({
        path: '/company-auth',
        query: {
          planId: id
        }
      })
    },

    // 企业认证
    goToCompContract (id) {
      this.$router.push({
        path: '/company-auth',
        query: {
          planId: id
        }
      })
    },

    // //更换签署
    // changeContract (id) {
    //   this.$router.push({
    //     path:'/company-auth',
    //     query:{
    //       orderid: id
    //     }
    //   })
    // },

    // 发送授权
    sendContract (id) {
      this.$router.push({
        path: '/company-auth',
        query: {
          planId: id
        }
      })
    },

    // // 签署合同
    // goSignContract (id) {
    //   let newpage = this.$router.resolve({
    //     name: 'company-auth',
    //     query: {
    //       planId: id
    //     }
    //   })
    //   window.open(newpage.href, '_blank')
    //   // this.$router.push({
    //   //   path: '/company-auth',
    //   //   query: {
    //   //     planId: id
    //   //   }
    //   // })
    // },

    hetongOnline (id) {
      if (
        parseInt(localStorage.getItem('isApp')) === 1 &&
        this.utils.isIphone()
      ) {
        // ios app 内嵌网页 查看合同
        window.webkit.messageHandlers.contractLook.postMessage({
          planId: id,
          real: 1
        })
      } else {
        this.$router.push({ path: 'checkpdf', query: { planId: id, real: 1 } })
      }
    },
    getOrderData: function () {
      var _this = this
      this.utils.GET(
        this.companyUrl +
          '/zxOrder/orderOfSolutions?orderId=' +
          this.keyword +
          '&page=' +
          this.currentPage +
          '&pageSize=' +
          this.pageSize,
        function (res) {
          if (res.code === 0) {
            _this.allLists = res.data.rows
            _this.allLists.forEach((item, index) => {
              item.amount = _this.money_dot(item.amount)
            })
          }
        }
      )
    },
    download (id) {
      if (
        parseInt(localStorage.getItem('isApp')) === 1 &&
        this.utils.isIphone()
      ) {
        // ios app 内嵌下载文件
        window.webkit.messageHandlers.downloadFile.postMessage({ planId: id })
        return
      }
      window.open(
        this.accountUrl +
          '/solutionsConsulting/downSolutionsContractPFD?sId=' +
          id
      )
    },

    hetong (item) {
      if (
        parseInt(localStorage.getItem('isApp')) === 1 &&
        this.utils.isIphone()
      ) {
        // ios app 内嵌网页 线下查看合同
        window.webkit.messageHandlers.contractLook.postMessage({
          planId: item,
          real: 0
        })
        return
      }
      window.open(item)
    },

    showCanclPop (id) {
      this.popflag = true
      this.currentId = id
      document.body.style.overflow = 'hidden'
    },
    hideCanclPop () {
      this.popflag = false
      document.body.style.overflow = 'auto'
    },
    showDelPop (id) {
      this.popDelflag = true
      this.currentId = id
      document.body.style.overflow = 'hidden'
    },

    hideDelPop () {
      this.popDelflag = false
      document.body.style.overflow = 'auto'
    },

    showAccPop (id) {
      this.popAcceptflag = true
      this.currentId = id
      document.body.style.overflow = 'hidden'
    },

    hideAccPop () {
      this.popAcceptflag = false
      document.body.style.overflow = 'auto'
    },

    goApplicationInvoice () {
      this.popApplicateflag = true
      document.body.style.overflow = 'hidden'
    },

    hideAppliPop () {
      this.popApplicateflag = false
      document.body.style.overflow = 'auto'
    },

    cancalFun (id) {
      var _this = this
      this.utils.POST(
        this.companyUrl + '/zxOrder/cancelOrder?order_id=' + id,
        null,
        function (res) {
          if (res.code === 0) {
            _this.hideCanclPop()
            _this.getOrderData()
            setTimeout(() => {
              Toast('订单已取消')
            }, 500)
          }
        }
      )
    },

    delFun (id) {
      var _this = this
      this.utils.POST(
        this.companyUrl + '/zxOrder/deleteOrderOfSolutions?orderId=' + id,
        null,
        function (res) {
          if (res.code === 0) {
            _this.hideDelPop()
            _this.getOrderData()
            setTimeout(() => {
              Toast('订单已删除')
            }, 500)
          }
        }
      )
    },

    goAcceptance (id) {
      var _this = this
      this.utils.POST(
        this.companyUrl + '/zxOrder/acceptanceSolutions?sId=' + id,
        null,
        function (res) {
          if (res.code === 0) {
            _this.hideAccPop()
            _this.getOrderData()
            setTimeout(() => {
              Toast('订单已验收')
            }, 500)
          }
        }
      )
    }
  },
  mounted () {
    this.getOrderData()
  }
}
</script>
<style scoped>
.header {
  position: fixed;
  top: 0px;
  height: 55px;
  width: 100%;
}
.cssOrderList {
  margin-top: 55px;
  font-size: 0;
  background: #f0f0f0;
}
.cssOrderList .cssOrderListMapping {
  width: 100%;
  height: 50px;
  line-height: 50px;
  padding: 0 14px 0 15px;
  background: #ffffff;
  box-sizing: border-box;
  margin-bottom: 10px;
  border-bottom: 1px solid #eeeeee;
}
.cssOrderList .cssOrderListMapping .cssOrderListTitle {
  font-weight: bold;
  font-size: 16px;
  color: #000;
  font-family: " MicrosoftYaHei-Bold ";
}
.cssOrderList .cssOrderListMapping .cssOrderListSubTitle {
  font-weight: bold;
  font-size: 14px;
  color: #000;
  font-family: " MicrosoftYaHei-Bold ";
}
.cssOrderList .cssOrderListMapping .cssBack {
  height: 30px;
  width: 80px;
  font-size: 13px;
  line-height: 30px;
  float: right;
  background: none;
  border: none;
  margin-top: 10px;
  color: #999999;
}
.cssOrderList .cssOrderItemBox {
  height: 100%;
  width: 100%;
  padding: 10px 14.5px 0 14px;
}
.cssOrderList .cssOrderItemBox .cssItemBlock {
  position: relative;
  /* height: 231px; */
  width: 100%;
  padding: 19.5px 15.5px 20px 15.5px;
  background: #ffffff;
  margin-bottom: 10px;
  border-radius: 4px;
}
.cssOrderList .cssOrderItemBox .cssItemBlock .cssStatuTag {
  font-family: SourceHanSansCN-Regular;
  font-size: 13px;
  color: #c41335;
  text-align: left;
  margin-bottom: 12px;
  position: absolute;
  top: 19.5px;
  right: 15.5px;
}
.cssOrderList .cssOrderItemBox .cssItemBlock .cssOrderId {
  font-family: SourceHanSansCN-Regular;
  font-size: 13px;
  color: #999999;
  text-align: left;
  margin-bottom: 13px;
}
.cssOrderList .cssOrderItemBox .cssItemBlock .cssOrderCreateTime {
  font-family: SourceHanSansCN-Regular;
  font-size: 13px;
  color: #999999;
  text-align: left;
  margin-bottom: 13px;
}
.cssOrderList .cssOrderItemBox .cssItemBlock .cssTimeTip {
  position: relative;
  display: inline-block;
  background-color: #fecdcd;
  font-size: 12px;
  color: #c41335;
  padding: 4px 6.5px 3.5px 6px;
  line-height: 18.5px;
  border-radius: 20px;
  margin-bottom: 18px;
}
.cssOrderList .cssOrderItemBox .cssItemBlock .cssItemBody {
  position: absolute;
  left: calc(50% - 39px);
  font-family: SourceHanSansCN-Regular;
  font-size: 13px;
  color: #000000;
  text-align: left;
  margin-bottom: 18px;
}
.cssOrderList .cssOrderItemBox .cssItemBlock .cssItemSubject {
  position: relative;
  font-family: SourceHanSansCN-Regular;
  font-size: 13px;
  color: #000000;
  text-align: left;
  margin-bottom: 21px;
}
.cssOrderList .cssOrderItemBox .cssItemBlock .cssItemSubject .cssSubjectAmount {
  font-family: SourceHanSansCN-Regular;
  font-size: 13px;
  color: #000000;
  float: right;
}
.cssOrderList .cssOrderItemBox .cssItemBlock .cssItemTotal {
  font-family: SourceHanSansCN-Regular;
  font-size: 13px;
  color: #000000;
  text-align: right;
  margin-bottom: 18px;
}
.cssOrderList .cssOrderItemBox .cssItemBlock .cssItemTotal .cssTotalAmount {
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  font-weight: bold;
  color: #000000;
  text-align: right;
}
.cssOrderList .cssOrderItemBox .cssItemBlock .cssButtonBox {
  text-align: right;
}
.cssButtonCommon {
  width: 65px;
  height: 24.5px;
  background: #c41335;
  color: #ffffff;
  font-size: 13px;
  line-height: 22.5px;
  margin: 0;
  padding: 0;
  border: 1px solid transparent;
  text-align: center;
  margin-right: 12px;
  border-radius: 2.5px;
}
.cssButtonCommon.disable {
  width: 65px;
  height: 24.5px;
  background: #bdbdbd;
  color: #ffffff;
  font-size: 13px;
  line-height: 24.5px;
  margin: 0;
  padding: 0;
  border: 1px solid transparent;
  text-align: center;
  margin-right: 12px;
}
.cssButtonCommon.white {
  width: 65px;
  height: 24.5px;
  background: #ffffff;
  color: #000000;
  border: 1px solid #bdbdbd;
  font-size: 13px;
  line-height: 24.5px;
  margin: 0;
  padding: 0;
  text-align: center;
  margin-right: 12px;
}
.cssButtonCommon:last-child {
  margin-right: 0px;
}
.cssMaskerLayer {
  position: fixed;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: #000000;
  opacity: 0.4;
  z-index: 1000;
  top: 0;
  left: 0;
}
.OverFlow {
  overflow: hidden;
}
.cssPopWindow,
.cssPopDelWindow,
.cssPopAcceptWindow {
  position: fixed;
  top: 254pt;
  width: 300px;
  background: #ffffff;
  z-index: 1001;
  left: 0;
  right: 0;
  margin: 0 auto;
}
.cssPopTitle {
  height: 45px;
  background: #c41335;
}
.cssPopTitle p {
  text-align: left;
  font-size: 14px;
  color: #ffffff;
  height: 45px;
  line-height: 45px;
  margin-left: 22.5px;
}
.cssPopBody {
  padding: 0 14.5px 7.5px 0;
  box-sizing: border-box;
}
.cssWranningtext {
  margin-left: 22.5px;
  font-size: 14px;
  color: #000000;
  margin-top: 25px;
  margin-bottom: 43px;
}
.cssWranning {
  padding: 2px 8px 2px 8px;
  line-height: 19.5px;
  width: 19.5px;
  height: 19.5px;
  border-radius: 50%;
  background: #eea332;
  color: #ffffff;
  font-size: 14px;
  margin-right: 8px;
}
.cssBottombutton {
  text-align: right;
}
.cssTip {
  position: fixed;
  top: calc(50% - 150px);
  left: 0;
  right: 0;
  margin: 0 auto;
  text-align: center;
  width: 100px;
  height: 100px;
  font-size: 16px;
  color: #ffffff;
  background: #000000;
  opacity: 0.5;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/view/orderlist.vue